/** @format */

import {
	Directive,
	EventEmitter,
	Inject,
	Input,
	NgZone,
	OnDestroy,
	OnInit,
	Output,
	PLATFORM_ID
} from '@angular/core';
import { DeviceService, WINDOW } from '@shared/utils/services';

import { Subject, fromEvent } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { BreakPointType } from '@shared/data-access/enums';

@Directive({
	standalone: true,
	selector: '[resizeDeviceBreakPoint]'
})
export class ResizeDeviceBreakPointDirective implements OnInit, OnDestroy {
	@Input() isBreakpointNew = false;
	@Output() newDeviceBreakPoint = new EventEmitter<BreakPointType>();
	private destroy$ = new Subject<void>();

	constructor(
		@Inject(WINDOW) private window: Window,
		@Inject(PLATFORM_ID) private platformId,
		private deviceService: DeviceService,
		private ngZone: NgZone
	) {}

	ngOnInit(): void {
		if (isPlatformBrowser(this.platformId)) {
			this.setupOnResizeListener();
		}
	}

	/**
	 * @description adds a resize event listener to emit the new device break point
	 */
	private setupOnResizeListener(): void {
		const getCurrentBreakpoint = this.isBreakpointNew ?
			() => this.deviceService.getDeviceBreakPointNew(true) :
			() => this.deviceService.getDeviceBreakPoint(true);
		this.ngZone.runOutsideAngular(() => {
			fromEvent(this.window, 'resize')
				.pipe(
					map(() => getCurrentBreakpoint()),
					distinctUntilChanged(),
					takeUntil(this.destroy$)
				)
				.subscribe((newBreakpoint) => {
					this.newDeviceBreakPoint.emit(newBreakpoint);
				});
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
